import { validateHasDefaultKey } from '#/utils/validations';

const VikimapViewsIds = {
  AccedoOneContainer: 'AccedoOneContainer',
  Default: 'Default'
};

validateHasDefaultKey(VikimapViewsIds);

export default VikimapViewsIds;
